import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, type Auth } from 'firebase/auth';

/**
 * Firebase client identifiers come from the dashboard API at runtime via
 * GET /config (see ConfigGate). We initialize lazily once config is loaded
 * rather than at module-load time so no secrets are baked into the bundle.
 */
export interface FirebaseClientConfig {
  apiKey: string;
  authDomain: string;
  /** Optional Firebase Auth emulator host (E2E only). */
  authEmulatorHost?: string;
}

let authInstance: Auth | null = null;

export function initializeFirebase(config: FirebaseClientConfig): Auth {
  if (authInstance) return authInstance;
  const app: FirebaseApp = getApps()[0] ?? initializeApp(config);
  const auth = getAuth(app);
  if (config.authEmulatorHost) {
    connectAuthEmulator(auth, `http://${config.authEmulatorHost}`, { disableWarnings: true });
  }
  authInstance = auth;
  return authInstance;
}

export function getFirebaseAuth(): Auth {
  if (!authInstance) {
    throw new Error(
      'Firebase not initialized — ensure ConfigGate has loaded /config before using auth'
    );
  }
  return authInstance;
}
